import { lighten, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  text: {
    padding: '5px 10px',
    borderRadius: 20,
    color: theme.palette.error.contrastText,
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      fontSize: 18,
      marginLeft: 5
    },
    fontWeight: 400
  },
  red: {
    backgroundColor: lighten(theme.palette.error.light, 0.8),
    color: theme.palette.error.main
  },
  yellow: {
    backgroundColor: lighten(theme.palette.warning.light, 0.8),
    color: theme.palette.warning.main
  },
  lightYellow: {
    backgroundColor: lighten(theme.palette.warning.light, 0.9),
    color: 'rgba(255, 193, 7, 1)'
  },
  green: {
    backgroundColor: lighten(theme.palette.secondary.light, 0.8),
    color: theme.palette.secondary.main
  },
  lightGreen: {
    backgroundColor: lighten(theme.palette.secondary.light, 0.9),
    color: theme.palette.secondary.main
  },
  blue: {
    backgroundColor: lighten(theme.palette.info.light, 0.8),
    color: theme.palette.info.main
  },
  lightBlue: {
    backgroundColor: lighten(theme.palette.info.light, 0.9),
    color: theme.palette.info.light
  },
  grey: {
    backgroundColor: theme.palette.grey[500]
  },
  lightGrey: {
    backgroundColor: theme.palette.grey[300]
  },
  isLong: {
    fontSize: 13,
    display: 'flex'
  }
}))

export default useStyles
